@if (!isLoading) {
  <section class="no-account-container">
    <div class="no-account-content">
      <!-- Main Card -->
      <div class="welcome-card">
        <!-- Header -->
        <div class="welcome-header">
          <img ngSrc="../../../assets/img/brand/salesmax.png" width="2251" height="559" priority
            class="brand-logo" alt="Salesmax.ai" />
          <h1 class="welcome-title">Welcome, {{registeredUser.name}}!</h1>
          <p class="welcome-subtitle">Let's get you started with Salesmax CRM</p>
        </div>

        <!-- Pending Invitations (Priority Display) -->
        @if (accountsInNeedOfAcceptance && accountsInNeedOfAcceptance.length > 0) {
          <div class="pending-invites-section">
            <div class="section-header">
              <mat-icon class="header-icon">mark_email_read</mat-icon>
              <h2>You have pending workspace invitations</h2>
            </div>
            <p class="section-description">Accept an invitation to join your team's workspace</p>

            @for (account of accountsInNeedOfAcceptance; track account) {
              <div class="invite-card">
                <div class="invite-content">
                  <div class="invite-icon">
                    <mat-icon>business</mat-icon>
                  </div>
                  <div class="invite-details">
                    <h3 class="workspace-name">{{account.account.accountName | titlecase}}</h3>
                    <p class="invited-by">
                      Invited by <strong>{{account.addedBy.name | titlecase}}</strong>
                    </p>
                  </div>
                </div>
                <div class="invite-actions">
                  <button mat-stroked-button class="reject-button" (click)="rejectMembership(account)">
                    Decline
                  </button>
                  <button mat-raised-button color="primary" class="accept-button" (click)="acceptMembership(account)">
                    Accept & Join
                  </button>
                </div>
              </div>
            }

            <div class="divider-with-text">
              <span>or</span>
            </div>
          </div>
        }

        <!-- Main Action Section - Side by Side -->
        @if (accountsInNeedOfAcceptance == null || accountsInNeedOfAcceptance.length == 0) {
          <div class="choice-section">
            <p class="choice-prompt">Which best describes you?</p>

            <div class="choice-cards">
              <!-- Left Card - Business Owner (Highlighted Default) -->
              <div class="choice-card primary-choice">
                <div class="recommended-badge">
                  <mat-icon>star</mat-icon>
                  <span>Most Popular</span>
                </div>
                <div class="card-icon business-owner">
                  <mat-icon>store</mat-icon>
                </div>
                <h3>I have a Business</h3>
                <p class="card-description">Create a workspace for your business and get started with your free trial</p>
                <ul class="feature-list">
                  <li>
                    <mat-icon>check</mat-icon>
                    <span>3-day free trial</span>
                  </li>
                  <li>
                    <mat-icon>check</mat-icon>
                    <span>Full CRM access</span>
                  </li>
                  <li>
                    <mat-icon>check</mat-icon>
                    <span>Invite team members</span>
                  </li>
                </ul>
                <button mat-raised-button color="primary" class="choice-button"
                  (click)="createOrganzationButtonClicked()">
                  <mat-icon>add_business</mat-icon>
                  <span>Create Workspace</span>
                </button>
              </div>

              <!-- Right Card - Team Member -->
              <div class="choice-card secondary-choice">
                <div class="card-icon team-member">
                  <mat-icon>groups</mat-icon>
                </div>
                <h3>I'm Joining My Team</h3>
                <p class="card-description">Your admin will send you an invitation to join your company's workspace</p>
                <div class="waiting-state">
                  <mat-icon>schedule</mat-icon>
                  <div class="waiting-text">
                    <p class="waiting-title">Waiting for invitation</p>
                    <p class="waiting-subtitle">Once your admin invites you, you'll see the invitation here</p>
                  </div>
                </div>
                <div class="help-text">
                  <mat-icon>info</mat-icon>
                  <span>Ask your admin to invite you via email or phone number</span>
                </div>
              </div>
            </div>
          </div>
        }

        @if (accountsInNeedOfAcceptance && accountsInNeedOfAcceptance.length > 0) {
          <div class="alternative-action">
            <p class="alternative-text">Don't want to join these workspaces?</p>
            <button mat-stroked-button class="create-new-button" (click)="createOrganzationButtonClicked()">
              <mat-icon>add_business</mat-icon>
              <span>Create Your Own Workspace</span>
            </button>
          </div>
        }

        <!-- Footer -->
        <div class="card-footer">
          <a class="sign-out-link" routerLink='/sign-out' routerLinkActive="active">
            <mat-icon>logout</mat-icon>
            <span>Sign Out</span>
          </a>
        </div>
      </div>
    </div>
  </section>
}

@if (isLoading) {
  <div class="loading-container">
    <mat-spinner></mat-spinner>
    <p>Loading your account...</p>
  </div>
}
